// extracted by mini-css-extract-plugin
module.exports = {"content":"StudentServices_content__eVQXg","text":"StudentServices_text__31fWD"};